// Put this in a function for easier testing
export const getDocument = () => document;
